import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { hasPermission } from '../../../../auth/redux/authActions';
import { get } from 'lodash';
import './Notifications.scss';

const Notifications = ({ dashboard }) => {
  const stats = get(dashboard, 'stats.meta');
  if (!stats) {
    return null;
  }

  return (
    <div>
      <table className="table reminders-list">
        <colgroup>
          <col width="67%" />
          <col width="33%" />
        </colgroup>
        <thead />
        <tbody>
          {/*{!!stats.mtas_requiring_approval && (*/}
          {/*<tr>*/}
          {/*<td>*/}
          {/*You have&nbsp;*/}
          {/*<span className="text-secondary">*/}
          {/*{stats.mtas_requiring_approval}*/}
          {/*</span>*/}
          {/*&nbsp; mid term adjustments requiring approval*/}
          {/*</td>*/}
          {/*<td className="reminder-action">*/}
          {/*<Link to="/policies/mid-term-adjustments?status=quote" onlyActiveOnIndex>View MTAs</Link>*/}
          {/*</td>*/}
          {/*</tr>*/}
          {/*)}*/}
          {!!stats.renewals_awaiting_conversion && (
            <tr>
              <td>
                There are&nbsp;
                <span className="text-secondary">
                  {stats.renewals_awaiting_conversion}
                </span>
                &nbsp;renewals awaiting conversion
              </td>
              <td className="reminder-action">
                <Link to="/policies/renewals?status=renewal invited" onlyActiveOnIndex>
                  View renewals
                </Link>
              </td>
            </tr>
          )}

          {hasPermission('broker.approve') &&
            !!stats.broker_applications_awaiting_approval && (
              <tr>
                <td>
                  You have&nbsp;
                  <span className="text-secondary">
                    {stats.broker_applications_awaiting_approval}
                  </span>
                  &nbsp;broker applications awaiting approval
                </td>
                <td className="reminder-action">
                  <Link to="/admin/broker-applications?status=applied" onlyActiveOnIndex>
                    View Broker Applications
                  </Link>
                </td>
              </tr>
            )}

          {hasPermission('user.edit') && !!stats.users_awaiting_activation && (
            <tr>
              <td>
                You have&nbsp;
                <span className="text-secondary">{stats.users_awaiting_activation}</span>
                &nbsp;users yet to log in
              </td>
              <td className="reminder-action">
                <Link to="/admin/users?status=pending" onlyActiveOnIndex>
                  View Users
                </Link>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default connect((state) => ({
  dashboard: state.dashboard,
}))(Notifications);
